import { CardContent, CardHeader, Divider } from '@mui/material';
import { Typography } from '@uhc-tempo/components';
import FlagIcon from '@mui/icons-material/Flag';
import React from 'react';

const LocationSearchErrorCard = (props) => {
    const { emptyLocation, classes } = props;
    return (
        <React.Fragment>
            <CardHeader
                sx={{ pt: 0, pb: 0 }}
                subheader={emptyLocation ? '' : 'Verify the location.'}
            />
            <CardContent sx={{ pt: 0, pb: 0 }}>
                {!emptyLocation ? (
                    <Typography.Paragraph>
                        <span style={{ padding: '8px 0px', fontSize: '15px' }}>
                            <span style={{ paddingLeft: '5px', lineHeight: 2 }}>
                                You can also enter a new street address, or city & state, or 5 digit
                                zip code.
                            </span>
                        </span>
                    </Typography.Paragraph>
                ) : (
                    <Typography.Paragraph>
                        <span
                            style={{
                                padding: '8px 14px',
                                borderRadius: '3px',
                                fontSize: '14px',
                                background: '#ADD8E6',
                            }}
                        >
                            <span
                                style={{
                                    lineHeight: 2,
                                    color: '#0008B',
                                    position: 'relative',
                                    top: '6px',
                                }}
                            >
                                {' '}
                                <FlagIcon />{' '}
                            </span>
                            <span style={{ paddingLeft: '5px', lineHeight: 2 }}>
                                You must enter city, state, or 5 digit zip code.
                            </span>
                        </span>
                    </Typography.Paragraph>
                )}
            </CardContent>
            <Divider sx={classes.divider} data-testid="headerDivider"></Divider>
        </React.Fragment>
    );
};

export default LocationSearchErrorCard;
